import { render, staticRenderFns } from "./EditWorkFlow.vue?vue&type=template&id=9f84cf34&scoped=true"
import script from "./EditWorkFlow.vue?vue&type=script&lang=js"
export * from "./EditWorkFlow.vue?vue&type=script&lang=js"
import style0 from "./EditWorkFlow.vue?vue&type=style&index=0&id=9f84cf34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f84cf34",
  null
  
)

export default component.exports